import React from 'react';
import { Add } from 'lib/@mui/Icons';
import { Button } from 'lib/@mui';

import { EZLOGIC_TITLE_CREATE_NEW_TEMPLATE } from 'constants/language_tokens';
import { useTranslate } from 'features/languages';

import notificationStyles from '../../EzloOEMNotiications.module.scss';

export const CreateNotificationTemplateButton = ({ onClickCreateNewTemplateButton }) => {
    const { t } = useTranslate();

    return (
        <Button
            color="primary"
            variant="contained"
            className={notificationStyles.createTemplateBtn}
            onClick={onClickCreateNewTemplateButton}
        >
            <Add />
            <span>{t(EZLOGIC_TITLE_CREATE_NEW_TEMPLATE)}</span>
        </Button>
    );
};
